import { CodeEditor } from '@acrodata/code-editor';
import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';

import { AppSharedModule } from '../../app-shared.module';
import { UikitComponent } from './uikit.component';

@NgModule({
  declarations: [UikitComponent],
  imports: [
    AppSharedModule,
    CodeEditor,
    RouterModule.forRoot(
      [
        {
          path: 'uikit',
          component: UikitComponent,
        },
      ],
      {}
    ),
  ],
})
export class UikitModule {}
